export * from 'utils/bolt/geo.js';

import hooks from 'utils/hooks';

hooks.register('geo.search.response', async (response) => {
	return response.filter(r => {
		console.log(r);
		if (r.countryCode !== 'TW') return true;
		if (r.labelType === 'country') return false;
		r.label = r.label = r.label.replace(/(,\s*)?\btaiwan\b/gi, '');
		return true;
	});
});